import { render, staticRenderFns } from "./exams-mobile-dashboard-component.vue?vue&type=template&id=6c08cf00&scoped=true&"
import script from "./exams-mobile-dashboard-component.vue?vue&type=script&lang=ts&"
export * from "./exams-mobile-dashboard-component.vue?vue&type=script&lang=ts&"
import style0 from "./exams-mobile-dashboard-component.vue?vue&type=style&index=0&id=6c08cf00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08cf00",
  null
  
)

export default component.exports